import { Link } from "react-router-dom";

const ROLE_LABELS = {
  sauna: "Sauna", heater: "Heater", rocks: "Sauna rocks", controls: "Controls",
  heaterPackage: "Heater package", coldPlunge: "Cold plunge", hotTub: "Hot tub",
};

export function setupItems(s) {
  const items = [];
  ["sauna", "heater", "rocks", "controls", "heaterPackage"].forEach((k) => {
    if (s[k]) items.push({ role: ROLE_LABELS[k], p: s[k] });
  });
  (s.accessories || []).forEach((p) => items.push({ role: "Accessory", p }));
  ["coldPlunge", "hotTub"].forEach((k) => { if (s[k]) items.push({ role: ROLE_LABELS[k], p: s[k] }); });
  return items;
}

const Thumb = ({ item }) => (
  <Link to={`/product/${item.p.handle}`} className="flex items-center gap-3 group">
    <img src={(item.p.images || [])[0]} alt={item.p.title}
      className="w-12 h-12 object-cover rounded-md border border-white/10 shrink-0" />
    <div className="min-w-0">
      <p className="text-[10px] uppercase tracking-wider text-gold/80">{item.role}</p>
      <p className="text-cream/85 text-xs leading-tight truncate group-hover:text-gold transition-colors">{item.p.title}</p>
    </div>
  </Link>
);

export function SetupCard({ setup, featured, onAddToCart, onCustomize, onRequestQuote }) {
  const items = setupItems(setup);
  return (
    <div data-testid={`setup-card-${setup.id}`}
      className={`flex flex-col bg-charcoal border rounded-xl overflow-hidden ${featured ? "border-gold/60" : "border-white/10"}`}>
      <div className="relative">
        <img src={setup.heroImage} alt={setup.name} className="w-full h-44 object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal to-transparent" />
        <span className="absolute top-3 left-3 bg-gold text-espresso text-[11px] font-semibold px-3 py-1 rounded-full uppercase tracking-wider">
          {setup.tagline}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-serif text-xl text-cream">{setup.name}</h3>
        <p className="text-cream/60 text-sm mt-1">{setup.specs.saunaType} · {setup.specs.capacity} · {setup.specs.placement}</p>

        <div className="mt-4 space-y-2.5">
          {items.slice(0, featured ? 12 : 4).map((it, i) => <Thumb key={i} item={it} />)}
          {!featured && items.length > 4 && (
            <p className="text-cream/40 text-xs pl-1">+ {items.length - 4} more included</p>
          )}
        </div>

        {setup.compatibilityNote && (
          <p className="text-cream/45 text-[11px] mt-4 italic border-l-2 border-gold/30 pl-2">{setup.compatibilityNote}</p>
        )}

        <div className="mt-auto pt-5">
          <div className="grid grid-cols-1 gap-2">
            <button data-testid={`request-quote-${setup.id}`} onClick={() => onRequestQuote(setup)}
              className="bg-gold text-espresso py-2.5 rounded-md font-medium hover:bg-amber transition-colors">
              Request a Quote
            </button>
            <div className="grid grid-cols-2 gap-2">
              <button data-testid={`add-setup-${setup.id}`} onClick={() => onAddToCart(setup)}
                className="border border-gold/50 text-gold py-2 rounded-md text-sm hover:bg-gold/10 transition-colors">
                Add to Cart
              </button>
              <button data-testid={`customize-setup-${setup.id}`} onClick={() => onCustomize(setup)}
                className="border border-white/15 text-cream/80 py-2 rounded-md text-sm hover:border-cream transition-colors">
                Customize
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
